import {
  Role,
  RolePermissions,
  rolePermissionsMap,
} from "@/constants/rolePermissions";
import { useAuth } from "@/contexts/AuthContext";

const useRolePermissions = (): RolePermissions & {
  role?: Role;
  userId?: string;
} => {
  const { user, profile } = useAuth();
  const role = profile?.role as Role | undefined;
  const userId = user?.id;

  const permissions = role ? rolePermissionsMap[role] : undefined;

  return {
    canCreate: permissions?.canCreate ?? false,
    canEdit: permissions?.canEdit ?? false,
    canDelete: permissions?.canDelete ?? false,
    canDownload: permissions?.canDownload ?? false,

    canCreateReservation: permissions?.canCreateReservation ?? false,
    canEditReservation: permissions?.canEditReservation ?? false,
    canCancelReservation: permissions?.canCancelReservation ?? false,

    canClickPastDates: permissions?.canClickPastDates ?? false,
    canClickFutureDates: permissions?.canClickFutureDates ?? false,
    canClickBlockedDates: permissions?.canClickBlockedDates ?? false,
    canClickBookedDates: permissions?.canClickBookedDates ?? false,

    canBlockDate: permissions?.canBlockDate ?? false,
    canUnblockDate: permissions?.canUnblockDate ?? false,

    role,
    userId,
  };
};

export default useRolePermissions;
